import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import common_en from "./en/common.json";
import common_no from "./no/common.json";
import common_sv from "./sv/common.json";
import edit_en from "./en/edit.json";
import edit_no from "./no/edit.json";
import edit_sv from "./sv/edit.json";
import attachment_en from "./en/attachment.json";
import attachment_no from "./no/attachment.json";
import attachment_sv from "./sv/attachment.json";
import errors_en from "./en/errors.json";
import errors_no from "./no/errors.json";
import errors_sv from "./sv/errors.json";

i18n.use(LanguageDetector).init({
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: ['querystring'],
        lookupQuerystring: 'lng',
    },
    fallbackLng: 'en',
    resources: {
        en: {
            common: common_en,
            edit: edit_en,
            attachment: attachment_en,
            errors: errors_en,
        },
        nb: {
            common: common_no,
            edit: edit_no,
            attachment: attachment_no,
            errors: errors_no,
        },
        sv: {
            common: common_sv,
            edit: edit_sv,
            attachment: attachment_sv,
            errors: errors_sv,
        },
    }
});

export default i18n;